import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "@/views/Home";

import MainAiEdu from "@/views/aiEdu/Main";
import ContentAiclass from "@/views/aiEdu/Aiclass";
import AiB2b from "@/views/aiEdu/AiB2b";

import MainCpEdu from "@/views/cpEdu/MainCpEdu";
import ContentProviederEduSell from "@/views/cpEdu/ContentProviederEduSell";
import CpMallEduSell from "@/views/cpEdu/CpMallEduSell";

import MainOnlineEdu from "@/views/onlineEdu/MainOnlineEdu";
import SpecialHighSchoolEduSell from "@/views/onlineEdu/SpecialHighSchoolEduSell";
import UniEduSell from "@/views/onlineEdu/UniEduSell";

import MainZoomEdu from "@/views/zoomEdu/MainZoomEdu";
import ZoomEduSell from "@/views/zoomEdu/ZoomEduSell";

import NewsRelease from "@/views/newsRelease/MainNewsRelease"
import PromotionVideo from "@/views/newsRelease/PromotionVideo"
import News1 from "@/views/newsRelease/news1"
import News2 from "@/views/newsRelease/news2"
import News3 from "@/views/newsRelease/news3"
import News4 from "@/views/newsRelease/news4"
import News5 from "@/views/newsRelease/news5"
import News6 from "@/views/newsRelease/news6"
import News7 from "@/views/newsRelease/news7"
import News8 from "@/views/newsRelease/news8"
import News9 from "@/views/newsRelease/news9"
import News10 from "@/views/newsRelease/news10"
import News11 from "@/views/newsRelease/news11"
import News12 from "@/views/newsRelease/news12";
import News13 from "@/views/newsRelease/news13";
import News14 from "@/views/newsRelease/news14";
import News15 from "@/views/newsRelease/news15";
import News16 from "@/views/newsRelease/news16";
import News17 from "@/views/newsRelease/news17";
import News18 from "@/views/newsRelease/news18";
import News19 from "@/views/newsRelease/news19";
import News20 from "@/views/newsRelease/news20";
import News21 from "@/views/newsRelease/news21";
import News22 from "@/views/newsRelease/news22";
import News23 from "@/views/newsRelease/news23";
import News24 from "@/views/newsRelease/news24";
import News25 from "@/views/newsRelease/news25";
import News26 from "@/views/newsRelease/news26";

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/edu/aiEdu/main',
		name: 'MainAiedu',
		component: MainAiEdu
	},
	{
		path: '/edu/aiEdu/aiclass',
		name: 'ContentAiclass',
		component: ContentAiclass
	},
	{
		path: '/edu/aiEdu/b2b',
		name: 'AiB2b',
		component: AiB2b
	},
	{
		path: '/edu/cpEdu/main',
		name: 'MainCpEdu',
		component: MainCpEdu
	},
	{
		path: '/edu/cpEdu/contentProviederEdu',
		name: 'ContentProviederEduSell',
		component: ContentProviederEduSell
	},
	{
		path: '/edu/cpEdu/cpMallEdu',
		name: 'CpMallEdu',
		component: CpMallEduSell
	},
	{
		path: '/edu/onlineEdu/main',
		name: 'MainOnlineEdu',
		component: MainOnlineEdu
	},
	{
		path: '/edu/onlineEdu/uniSell',
		name: 'UniSell',
		component: UniEduSell
	},
	{
		path: '/edu/onlineEdu/highSell',
		name: 'SpecialHighSchoolEduSell',
		component: SpecialHighSchoolEduSell
	},
	{
		path: '/edu/zoomEdu/main',
		name: 'MainZoomEdu',
		component: MainZoomEdu
	},
	{
		path: '/edu/zoomEdu/zoomEdu',
		name: 'ZoomEdu',
		component: ZoomEduSell
	},
	{
		path: '/edu/newsRelease/main',
		name: 'NewsRelease',
		component: NewsRelease
	},
	{
		path: '/edu/newsRelease/promotionVideo',
		name: 'PromotionVideo',
		component: PromotionVideo
	},
	{
		path: '/edu/newsRelease/promotionVideo/news1',
		name: 'News1',
		component: News1
	},
	{
		path: '/edu/newsRelease/promotionVideo/news2',
		name: 'News2',
		component: News2
	},
	{
		path: '/edu/newsRelease/promotionVideo/news3',
		name: 'News3',
		component: News3
	},
	{
		path: '/edu/newsRelease/promotionVideo/news4',
		name: 'News4',
		component: News4
	},
	{
		path: '/edu/newsRelease/promotionVideo/news5',
		name: 'News5',
		component: News5
	},
	{
		path: '/edu/newsRelease/promotionVideo/news6',
		name: 'News6',
		component: News6
	},
	{
		path: '/edu/newsRelease/promotionVideo/news7',
		name: 'News7',
		component: News7
	},
	{
		path: '/edu/newsRelease/promotionVideo/news8',
		name: 'News8',
		component: News8
	},
	{
		path: '/edu/newsRelease/promotionVideo/news9',
		name: 'News9',
		component: News9
	},
	{
		path: '/edu/newsRelease/promotionVideo/news10',
		name: 'News10',
		component: News10
	},
	{
		path: '/edu/newsRelease/promotionVideo/news11',
		name: 'News11',
		component: News11
	},
	{
		path: '/edu/newsRelease/promotionVideo/news12',
		name: 'News12',
		component: News12
	},
	{
		path: '/edu/newsRelease/promotionVideo/news13',
		name: 'News13',
		component: News13
	},
	{
		path: '/edu/newsRelease/promotionVideo/news14',
		name: 'News14',
		component: News14
	},
	{
		path: '/edu/newsRelease/promotionVideo/news15',
		name: 'News15',
		component: News15
	},
	{
		path: '/edu/newsRelease/promotionVideo/news16',
		name: 'News16',
		component: News16
	},
	{
		path: '/edu/newsRelease/promotionVideo/news17',
		name: 'News17',
		component: News17
	},
	{
		path: '/edu/newsRelease/promotionVideo/news18',
		name: 'News18',
		component: News18
	},
	{
		path: '/edu/newsRelease/promotionVideo/news19',
		name: 'News19',
		component: News19
	},
	{
		path: '/edu/newsRelease/promotionVideo/news20',
		name: 'News20',
		component: News20
	},
	{
		path: '/edu/newsRelease/promotionVideo/news21',
		name: 'News21',
		component: News21
	},
	{
		path: '/edu/newsRelease/promotionVideo/news22',
		name: 'News22',
		component: News22
	},
	{
		path: '/edu/newsRelease/promotionVideo/news23',
		name: 'News23',
		component: News23
	},
	{
		path: '/edu/newsRelease/promotionVideo/news24',
		name: 'News24',
		component: News24
	},
	{
		path: '/edu/newsRelease/promotionVideo/news25',
		name: 'News25',
		component: News25
	},
	{
		path: '/edu/newsRelease/promotionVideo/news26',
		name: 'News26',
		component: News26
	},
	{
		path: '/:pathMatch(.*)*',
		redirect: "/"
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 페이지 이동시 TOP으로 이동
		return {x: 0, y: 0}
	}
})

export default router
